// extracted by mini-css-extract-plugin
export var cartIcon = "_os-0";
export var cartIconContainer = "_os-1";